export enum PERMISSION {
	empty = 'empty',
	INVISION_DESKTOP = 'desktop:access',
	INVISION_DESKTOP_SEARCHALL = 'desktop:searchall',
	INVISION_DESKTOP_FORCEUNLOCK = 'desktop:forceunlock',
	INVISION_DESKTOP_DATA_ANALYST = 'desktop:rulehandler',
	INVISION_DESKTOP_APPROVER = 'desktop:approver',
	INVISION_DESKTOP_EDIT_ORDER = 'desktop:edit-order',
	INVISION_DESKTOP_EXPORT_DATA = 'desktop:export-data',
	INTELLIGENCE = 'intelligence:access',
	INTELLIGENCE_FORCEUNLOCK = 'intelligence:forceunlock',
	INTELLIGENCE_EDIT_ORDER = 'intelligence:edit-order',
	DASHBOARD_ALL = 'intelligence:dashboardall',
	SMART_ASSIGN_CAN_ACCESS = 'smartassign:access',
	SMART_ASSIGN_CAN_EDIT = 'smartassign:edit-block',
}
